import { Point } from 'electron';

export interface RoomTable {
  clientId?: number;
  roomId?: number;
  id?: number;
  name?: string;
  isCombined: Boolean;
  isActive: Boolean;
  seats: number;
  minOccupancy: Number;
  combinedTables: string;
  selected?: boolean;
  isFree?: boolean;
  position: Point;
  type: string;
}

export interface Room {
  id?: number;
  clientId?: number;
  name: string;
  alert?: string;
  seats?: number;
  tables?: Array<any>;
  isActive: boolean;
  width: number;
  length: number;
  freeTablesCounter?: number;
}

export interface GeneralSettings {
  isActive: boolean;
  newVersion?: boolean;
  isAutomatic: boolean;
  autoPlace: boolean;
  roomChoice: boolean;
  roomChoiceMandatory?: boolean;
  email: string;
  paymentSystem?: boolean;
  requestCheckin?: boolean;
  sendFeedback?: boolean;
  remindGuests: boolean;
  remindGuestsEmail: boolean;
  remindGuestsTextMessage: boolean;
  reminderDays: number;
  reminderGroupSize: number;
  reservationInactiveText: string;
  isGoogleReserve: boolean;
  showSubscribeNewsletter: boolean;
  reminderSMSText: string;
  reservationUntil: string;
  showStayTime: boolean;
  termsConditions?: string;
  paymentTransactionFee: number;
  showTranslation: boolean;
  defaultLang: string;
  maxStayTimeSetting: number;
}

export interface ReservationBookSettings {
  timeInterval: number;
  defaultStaytime: number;
  requestStaff: boolean;
  requestStaffCode?: boolean;
  confirmStatusChange: boolean;
  arrivedStatus: boolean;
  waitingStatus: boolean;
  highlightNew?: boolean;
  showStatus?: boolean;
  showWalkIns?: boolean;
  startTime: number;
  endTime: number;
  showOccupancy: boolean;
  showTablePlan: boolean;
  includeShift: number;
  showTimeFilter?: boolean;
  showReservationId?: boolean;
  phoneNoRequired?: boolean;
  showCanceledRes?: boolean;
  defaultTimeResBook?: string;
  showGuestEmail?: boolean;
  displayNameFormat?: string;
}

export interface TextPresets {
  acceptText: string;
  declineText: string;
  cancelText: string;
  reminderText: string;
  infoText: string;
  noMoreReservationMsg: string;
}

export interface Shift {
  clientId?: number;
  color: string;
  name: string;
  description?: string;
  info?: string;
  emailInfo?: string;
  rooms: Array<any>;
  minGuests: number;
  maxGuests: number;
  buffer: number;
  interval: number;
  noReservationAfterShiftStart: boolean;
  stayTimeType: string;
  staticStayTime?: number;
  stayTime1?: number;
  stayTime2?: number;
  stayTimes: any;
  maxGuestsPerUnit: any;
  questions?: any;
  isRWGShift: boolean;
}

export class Timeplan {
  recurrence: string;
  name: string;
  startDate: Date;
  endDate: Date;
  color: string;
  isBlocked: boolean;
}

export class Notification {
  type: string;
  value: string;
  clientId?: number;
}

export class Alert {
  dateFrom: Date;
  dateTo?: Date;
  info: string;
  type: string;
  clientId?: number;
  file: File;
}

export class Tag {
  clientId?: number;
  label: string;
  color: string;
}

export class Question {
  id?: number;
  clientId: number;
  name: string;
  question: string;
  answers: any;
  answer?: boolean;
  createdAt?: string;
  updatedAt?: string;
  questionType: number;
  foreignId: number;
  multiSelect: number;
}

export class PaymentTemplate {
  clientId?: number;
  name: string;
  minGuests: number;
  priceOption: string;
  price: number;
}

export interface ReservationPdfSettings {
  showTags?: boolean;
  showGuestNotes?: boolean;
  showAdminNotes?: boolean;
  showRoomNumber?: boolean;
  showArrivingDate?: boolean;
  showDepartureDate?: boolean;
  showBoard?: boolean;
  showEndTime?: boolean;
}

export interface NameDisplayOption {
  value: NameDisplayFormat;
  label: string;
  isDefault?: boolean;
}

export enum NameDisplayFormat {
  FirstLast = 'firstLast',
  LastFirst = 'lastFirst',
  FirstLastInitial = 'firstLastInitial',
  FirstInitialLast = 'firstInitialLast',
  LastInitialFirst = 'lastInitialFirst',
  LastFirstInitial = 'lastFirstInitial'
}
